// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/header-v2/header-v2.component.scss
// module id = 347
// module chunks = 0